import { useState } from 'react';
import type { Contact } from '../../../types/contact';

const MAX_CONTACTS = 5;

interface UseContactMultiSelectionParams {
  contacts: Contact[];
  initialContacts?: Contact[];
}

export function useContactMultiSelection({ contacts, initialContacts }: UseContactMultiSelectionParams) {
  const [selectedContactsMap, setSelectedContactsMap] = useState<Map<number, Contact>>(() => {
    if (initialContacts && initialContacts.length > 0) {
      return new Map(initialContacts.map((c) => [c.id, c]));
    }
    return new Map();
  });
  const [limitError, setLimitError] = useState<string | null>(null);

  const handleToggleContactSelection = (id: number) => {
    const item = contacts.find((x) => x.id === id);
    if (!item) {
      return;
    }

    if (!selectedContactsMap.has(id) && selectedContactsMap.size >= MAX_CONTACTS) {
      setLimitError(`Ви можете вибрати максимум ${MAX_CONTACTS} контактів`);
      return;
    }

    setLimitError(null);
    setSelectedContactsMap((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(id)) {
        newMap.delete(id);
      } else {
        newMap.set(id, item);
      }
      return newMap;
    });
  };

  const handleClearLimitError = () => {
    setLimitError(null);
  };

  return {
    data: {
      selectedContactsMap,
      limitError,
    },
    actions: {
      handleToggleContactSelection,
      handleClearLimitError,
    },
  };
}
